const conversionRates = {
	kilogramsAndPounds: 2.2046,
	poundsAndOunces: 16,
	ouncesAndKilograms: 0.02834952,
	poundsInKilogram: 0.453592,
	inchInMeters: 0.0254,
};

export { conversionRates };
